/** AXA TEMPLATE PACKAGE *************************************************/
var axa = axa || (function () {
    return {};
})();

/*** PLEASE WAIT MANAGEMENT - SUB AXA PACKAGE ************************/
axa.pleaseWait = axa.pleaseWait || (function() {

    /* ----- Private variables and methods ---- */


    return {
        /* ---- Public variables and methods ------ */

        show: function () {
            $('#axa-pleaseWait-dialog').modal('show');
        },
        hide: function () {
            $('#axa-pleaseWait-dialog').modal('hide');
        }
    };
})();